import mongoose, { Schema } from 'mongoose';
import { AvailableStatusEnum, LabourDocument, LabourModel } from '../interfaces/labour.interface';
import statusEnum from '../constant/status.json';
const CertificateSchema = new Schema({
    name: { type: String },
    file: { type: Schema.Types.ObjectId, ref: 'Attachment', required: true },
});

const IdentificationSchema = new Schema({
    type: { type: String, required: true },
    file: { type: Schema.Types.ObjectId, ref: 'Attachment', required: true },
    issuedAt: { type: Date },
    expiresAt: { type: Date },
});

const LabourSchema = new Schema<LabourDocument>(
    {
        userId: { type: Schema.Types.ObjectId, required: true, ref: 'User' },
        employee_id: { type: String },
        availability_status: {
            type: String,
            enum: Object.values(AvailableStatusEnum),
            default: AvailableStatusEnum.AVAILABLE,
        },
        skills: [{
            type: String,
            enum: Object.values(statusEnum.Skills),
        }],
        isDeleted: { type: Boolean, default: false },
        deletedAt: { type: Date, default: null },
        profileCompletionStatus: {
            type: String,
            enum: Object.values(statusEnum.profileCompletionStatuses),
            default: statusEnum.profileCompletionStatuses.PENDING,
        },
        profileCompletionPercentage: {
            type: Number,
            default: 0,
            min: 0,
            max: 100,
        },
        profileCompletedAt: { type: Date, default: null },
        certificates: [CertificateSchema],
        identification: [IdentificationSchema],
        experienceSummary: { type: String },
        occupation: { type: String, enum: Object.keys(statusEnum.Occupation) },
        sitesInductedOn: [{ type: String }],
        tickets: [{
            type: String,
            enum: Object.keys(statusEnum.tickets),
        }],
        draft: { type: Boolean, default: true },
        isFirstUpdate: { type: Boolean, default: true },
        availability: [{ type: Schema.Types.ObjectId, ref: 'Availability', default: [] }],
        allocationRequest: [{ type: Schema.Types.ObjectId, ref: 'AllocationRequest', default: [] }],
        averageRating: {
            type: Number,
            default: 0,
            min: 0,
            max: 5,
            get: (v: number) => Number(v.toFixed(1)),
        },
        ratingCount: {
            type: Number,
            default: 0,
            min: 0
        },
    },
    {
        timestamps: true,
        versionKey: false,
    }
);

LabourSchema.index({ userId: 1 }, { unique: true });
LabourSchema.index({ employee_id: 1 }, { unique: true, sparse: true });

LabourSchema.pre('save', async function (next) {
    const labour = this as LabourDocument;
    try {
        if (!this.employee_id) {
            const lastLabour = await mongoose.model<LabourDocument>('Labour')
                .findOne({ employee_id: { $exists: true } })
                .sort({ created_at: -1 })
                .select('employee_id')
                .session(this.$session())
                .lean();
            let nextNumber = 1;
            if (lastLabour && lastLabour.employee_id) {
                const parts = lastLabour.employee_id.split('-');
                const number = parseInt(parts[1], 10);
                if (!isNaN(number)) {
                    nextNumber = number + 1;
                }
            }
            this.employee_id = `LBR-${nextNumber.toString().padStart(4, '0')}`;
        }

        // if (this.isNew) {
        //     const session = this.$session();
        //     const user = await mongoose.model<IUser>('User')
        //         .findById(this.userId)
        //         .select('roleId')
        //         .populate('roleId', 'name')
        //         .session(session)
        //         .lean();
        //     if (!user || (user.roleId as any).name.toLowerCase() !== 'labour') {
        //         return next(new HttpException(status.BadRequest, 'Invalid labour user'));
        //     }
        //     const availability = await new Availability({
        //         userId: this.userId,
        //         startDate: new Date(),
        //         endDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
        //         status: AvailableStatusEnum.AVAILABLE,
        //         createdBy: this.userId,
        //         updatedBy: this.userId,
        //     }).save({ session });

        //     this.availability = [availability._id];
        //     this.availability_status = AvailableStatusEnum.AVAILABLE;
        // }



        next();
    } catch (error) {
        console.error('Error in Labour pre-save hook:', error);
        next(error);
    }
});

LabourSchema.statics.cleanupReferences = async function (
    userId: string,
    refId: string,
    refType: 'Availability' | 'AllocationRequest',
    options?: { session?: mongoose.ClientSession }
) {
    const field = refType === 'Availability' ? 'availability' : 'allocationRequest';
    const updateOptions: mongoose.mongo.UpdateOptions = {};
    if (options?.session) {
        updateOptions.session = options.session;
    }

    await this.updateOne(
        { userId, isDeleted: false },
        { $pull: { [field]: refId } },
        updateOptions
    );
};

const Labour = mongoose.model<LabourDocument, LabourModel>('Labour', LabourSchema);
export default Labour;